import { Box } from '@mui/system';
import React from 'react';
import { lengthOfInput } from '../../../constants/trainings';

import { nbMaxToken} from "../../../constants/trainings";

const ContentLength = ({
  characterCount,
  contractType,
  nbToken,
  spacing = false,
  margin = '0 50px 0 0',
  limitter = lengthOfInput,
}) => {
   let tokenMention= '';
   if (contractType.includes('oken'))
{
       tokenMention = '( soit ' +  nbToken+  ' token';
       if (nbToken > 1) {
           tokenMention += 's';
       }
   tokenMention += ' )';
   }

  return (
    <Box
      sx={{
        fontSize: '12px',
        color: 'gray',
        textAlign: 'right',
        marginBottom: spacing ? '20px' : '10px',
        margin: margin,
      }}
    >
      {characterCount}/{limitter} caractères { tokenMention }
    </Box>
  );
};

export default ContentLength;
